import styled, { css } from 'styled-components';
import { darkMode, darkPalette } from '../../core/theme';

export const Title = styled.div`
  font-weight: 700;
  font-size: 24px;
  line-height: 32px;
  color: #3393ec;
  text-align: center;

  ${darkMode(css`
    color: ${darkPalette.accent};
  `)}
`;

export const Description = styled.div`
  font-size: 14px;
  line-height: 20px;
  color: #919191;
  margin-top: 12px;
  text-align: center;

  & > span {
    text-decoration: underline;
    cursor: pointer;
    white-space: nowrap;
  }

  ${darkMode(css`
    color: ${darkPalette.textTertiary};
  `)}
`;
